import $api from '../services';

export default {
    createEvent(params) {
        return $api.post(`/system-events`, params);
    }
};
